import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=73889ee4&"
import script from "./Formular.vue?vue&type=script&lang=js&"
export * from "./Formular.vue?vue&type=script&lang=js&"
import style0 from "./Formular.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports